import React from 'react'
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import Avatar from '@mui/material/Avatar';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import img from '../Assets/Images/BNBCLogo.png'
import img2 from '../Assets/Images/logo.png'
import "../Assets/CSS/Sidebar.css"

const Appbar = ({ handleDrawerToggle }) => {

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="fixed"
        sx={{
          background: "#232529",
        }}>
        <Toolbar>
          <IconButton
            size="large"
            edge="start"
            // color="inherit"
            sx={{ ml: { md: "110px" } }}
            onClick={handleDrawerToggle}
          >
            <MenuIcon sx={{ color: "white" }} />
          </IconButton>
          <img src={img} />
          <Box sx={{ flexGrow: 1 }} />
          <div className='logoborder'></div>
          <div className='logoback'>
            <img className='logoimg' src={img2} />
          </div>

          <Box>
          </Box>
        </Toolbar>
      </AppBar>
    </Box>
  )
}

export default Appbar